//@ts-nocheck
import BookingTotalsHeaderItem from '../BookingTotalsHeaderItem/BookingTotalsHeaderItem';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../../../../utils/currencyHelper';
import { isValidDate } from '../../../../../utils/dateUtility';
import { formatInTimeZone } from 'date-fns-tz';
import * as PropTypes from 'prop-types';
import './BookingTotalsHeader.css';

/**
 * Functional React component for rendering a custom booking totals header.
 *
 * @namespace Components
 *
 * @param {Object} props - The component's properties
 * @param {string} [props.id] - The ID for the booking totals header component.
 * @param {Object} [props.data] - The data for the booking totals header component.
 * @param {number} [props.data.bookingTotal] - The booking total amount.
 * @param {number} [props.data.amountReceived] - The amount received.
 * @param {number} [props.data.totalDue] - The total due amount.
 * @param {string} [props.data.bookingDate] - The booking date.
 * @param {string} [props.data.departureDate] - The departure date.
 * @param {...any} props.rest - Additional props to be spread on the parent element.
 *
 * @returns {JSX.Element} React element representing the booking totals header.
 */
const BookingTotalsHeader = ({ id, data = {}, ...rest }) => {
  const { t } = useTranslation(['bookings']);

  const getDateItem = (date) => {
    if (!isValidDate(date)) {
      return '';
    }

    return formatInTimeZone(date, 'UTC', 'MMMM d, yyyy');
  };

  return (
    <Box
      className='booking-totals-header booking-totals-header__no-bottom-radius'
      id={id}
      {...rest}
    >
      <BookingTotalsHeaderItem
        id={'booking-totals-header-item-booking-total'}
        title={t('bookings:bookingTotal')}
        value={formatCurrency(data?.bookingtotal)}
      />
      <BookingTotalsHeaderItem
        id={'booking-totals-header-item-amount-received'}
        title={t('bookings:amountReceived')}
        value={formatCurrency(data?.amountreceived)}
      />
      <BookingTotalsHeaderItem
        id={'booking-totals-header-item-total-due'}
        title={t('bookings:balance')}
        value={formatCurrency(data?.totaldue)}
      />
      <BookingTotalsHeaderItem
        id={'booking-totals-header-item-total-passengers'}
        title={t('bookings:totalPassengers')}
        value={`${data?.participants || 0}`}
      />
      <div className='booking-panel-header-info-separator' />
      <BookingTotalsHeaderItem
        id={'booking-totals-header-item-booking-date'}
        title={t('bookings:bookingDate')}
        value={getDateItem(data?.bookingdate)}
      />
    </Box>
  );
};

BookingTotalsHeader.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.object
};

export default BookingTotalsHeader;
